"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _params = require("hub-http/helpers/params");

var _I18n = _interopRequireDefault(require("I18n"));

var _DocumentHead = _interopRequireDefault(require("ecosystem-marketplace-core/components/portals/DocumentHead"));

var _PrerenderReady = _interopRequireDefault(require("ecosystem-marketplace-core/components/prerender/PrerenderReady"));

var _auth = require("../../selectors/auth");

var _details = require("../../selectors/details");

var _useParsedPathParams2 = require("../../utils/hooks/useParsedPathParams");

var _useScrollToTop = require("../../utils/hooks/useScrollToTop");

var _requestState = require("../../utils/requestState");

var _NotFoundError = _interopRequireDefault(require("../../components/error/NotFoundError"));

var _GenericError = _interopRequireDefault(require("../../components/error/GenericError"));

var _NoAccessError = _interopRequireDefault(require("../../components/error/NoAccessError"));

var _DetailsActions = require("../../actions/DetailsActions");

var _DetailPage = _interopRequireDefault(require("../../components/detail/DetailPage"));

var DetailError = function DetailError(_ref) {
  var children = _ref.children,
      statusCode = _ref.statusCode;
  return _react.default.createElement(_react.Fragment, null, children, _react.default.createElement(_auth.PublicOnly, null, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_PrerenderReady.default, {
    statusCode: statusCode
  }))));
};

var DetailContainer = function DetailContainer(props) {
  var children = props.children,
      fetchDetails = props.fetchDetails,
      isAdminPreview = props.isAdminPreview,
      isCustomer = props.isCustomer,
      listingViewFetchError = props.listingViewFetchError,
      listingViewFetchStatus = props.listingViewFetchStatus,
      _props$location = props.location,
      pathname = _props$location.pathname,
      search = _props$location.search,
      _props$match = props.match,
      params = _props$match.params,
      path = _props$match.path;
  (0, _useScrollToTop.useScrollToTop)(pathname);

  var _useParsedPathParams = (0, _useParsedPathParams2.useParsedPathParams)(params),
      activeCategory = _useParsedPathParams.category,
      slug = _useParsedPathParams.slug;

  var _parseParams = (0, _params.parse)(search.slice(1)),
      published = _parseParams.published;

  var isPreview = published === 'false' || path === '/_preview/:slug' || isAdminPreview;
  var isShortlink = path.includes('/_detail/:slug');
  (0, _react.useEffect)(function () {
    if ((0, _requestState.isUninitialized)(listingViewFetchStatus)) {
      document.title = _I18n.default.text('appMarketplace.htmlTitle');
      var isPublished = !isPreview;
      fetchDetails(slug, isPublished, isAdminPreview, {
        path: path,
        search: search,
        isCustomer: isCustomer,
        activeCategory: activeCategory
      });
    }
  }, [fetchDetails, listingViewFetchStatus, activeCategory, isAdminPreview, isCustomer, isPreview, isShortlink, path, search, slug]);

  if (listingViewFetchError) {
    if (listingViewFetchError.status === 404) {
      return _react.default.createElement(DetailError, {
        statusCode: 404
      }, _react.default.createElement(_NavMarker.default, {
        name: "DETAIL_NOT_FOUND_ERROR_LOAD"
      }, _react.default.createElement(_NotFoundError.default, null)));
    } else if (listingViewFetchError.status === 403) {
      return _react.default.createElement(DetailError, {
        statusCode: 403
      }, _react.default.createElement(_NavMarker.default, {
        name: "DETAIL_NO_ACCESS_ERROR_LOAD"
      }, _react.default.createElement(_NoAccessError.default, {
        use: isPreview ? 'preview' : 'default'
      })));
    } else {
      return _react.default.createElement(DetailError, {
        statusCode: listingViewFetchError.status || 400
      }, _react.default.createElement(_NavMarker.default, {
        name: "DETAIL_ERROR_LOAD"
      }, _react.default.createElement(_GenericError.default, null)));
    }
  }

  if (!(0, _requestState.isSucceeded)(listingViewFetchStatus)) {
    return null;
  }

  if (children) {
    return children;
  }

  return _react.default.createElement(_DetailPage.default, props);
};

DetailContainer.propTypes = {
  children: _propTypes.default.node,
  listingViewFetchError: _propTypes.default.instanceOf(Error),
  listingViewFetchStatus: _propTypes.default.string.isRequired,
  fetchDetails: _propTypes.default.func.isRequired,
  isAdminPreview: _propTypes.default.bool,
  isCustomer: _propTypes.default.bool.isRequired,
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string.isRequired,
    search: _propTypes.default.string.isRequired
  }).isRequired,
  match: _propTypes.default.shape({
    params: _propTypes.default.object.isRequired,
    path: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired
  }).isRequired
};
DetailContainer.defaultProps = {
  isAdminPreview: false
};

var mapStateToProps = function mapStateToProps() {
  var getListingViewFetchStatus = (0, _details.makeGetListingViewFetchStatus)();
  var getListingViewFetchError = (0, _details.makeGetListingViewFetchError)();
  return function (state, ownProps) {
    var selectorProps = {
      slug: ownProps.match.params.slug
    };
    return {
      isCustomer: (0, _auth.getIsCustomer)(state),
      listingViewFetchError: getListingViewFetchError(state, selectorProps),
      listingViewFetchStatus: getListingViewFetchStatus(state, selectorProps)
    };
  };
};

var mapDispatchToProps = {
  fetchDetails: _DetailsActions.fetchDetails
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DetailContainer);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/containers/detail/DetailContainer.js
// module id = 601
// module chunks = 209 210 211 212